/* eslint-disable react-hooks/exhaustive-deps */
import { ContactFormContent, OVERLAY_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { getSCCBorderStyle } from "../../../utils/getBorderStyle"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { Icon, IconName, Popover, Position } from "@blueprintjs/core" 
import { ContactFormLayout } from "./ContactFormLayout"
import { ScalableDialog } from "src/libs/useful"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import CFAnimatedBorder from "./CFAnimatedBorder"

export const ContactFormOverlay = (props: IPrimitiveProps): JSX.Element => {
    const primitive: ContactFormContent = ( props.primitive || {} ) as ContactFormContent
    const position = usePosition( primitive, true ).position
    const [isOpen, setIsOpen] = useState<boolean>(false)
    useEffect(() => {
        const btn = document.querySelector(`.landing-overlay-cf-button hover landing-overlay-cf-${primitive.id}`)
        addCSSClass(
            `landing-overlay-cf-${primitive.id}`,
            `.landing-overlay-cf-${primitive.id} {
                cursor: pointer;
                background-color: ${primitive.overlayBg    || "var(--force-plain-color)"};
                width: ${ getCssDemention( position.width  || 50 )};
                height: ${getCssDemention( position.height || 50 )}; 
                ${getSCCBorderStyle(primitive.overlayBorder)} 
            }
            .landing-overlay-cf-popover-${primitive.id} { 
                transform: translateX(${ getCssDemention(position.left || 0) }) translateY(${ getCssDemention( position.top || 0 ) });
            }
            .cf-popover-container .cf-${primitive.id} {
                max-height: calc(100vh - ${ ( primitive.overlayButtonSize || 40 ) + 200 }px);
            }`
        )
        return () => removeCSSClass(`landing-overlay-cf-${primitive.id}`)
    }, [])
    const onOpen = () => {
        setIsOpen(true)
    }
    return <div style={{
        transform: `translateY(-${ (primitive.overlayButtonSize || 40) / 2 - 0 }px)`,
    }}>
        {
            primitive.overlayType === OVERLAY_TYPE.POPOVER
                ?
                <Popover
                    content={ <div className="cf-popover-container"><ContactFormLayout {...props} /></div> }
                    position={ Position.TOP_LEFT }
                    className={ `landing-overlay-cf-popover-${primitive.id}` }
                    
                >
                    <div 
                        className={ `landing-overlay-cf-button hover landing-overlay-cf-${primitive.id}` } 
                        style={{ 
                            width: primitive.overlayButtonSize, 
                            height: primitive.overlayButtonSize,
                            
                            borderRadius:primitive.overlayBorder?.borderRound?.border,
                            borderStyle: primitive.overlayBorder?.borderStyle,
                            borderColor: primitive.overlayBorder?.borderColor,
                            borderWidth: primitive.overlayBorder?.borderWidth,
                        }}
                    >
                        <Icon 
                            icon={ primitive.overlayIcon as IconName || "phone-call"} 
                            size={ primitive.overlayIconSize || 22 } 
                            color={ primitive.overlayIconColor }
                        />
                        <CFAnimatedBorder primitive={ primitive } />
                    </div>
                </Popover>
                :
                primitive.overlayType === OVERLAY_TYPE.MODAL
                    ?
                   
                        <>
                            <div 
                                className={ `landing-overlay-cf-button hover landing-overlay-cf-${primitive.id} ` } 
                                style={{ 
                                    width: primitive.overlayButtonSize, 
                                    height: primitive.overlayButtonSize,
                                    
                                    borderRadius:primitive.overlayBorder?.borderRound?.border,
                                    borderStyle: primitive.overlayBorder?.borderStyle,
                                    borderColor: primitive.overlayBorder?.borderColor,
                                    borderWidth: primitive.overlayBorder?.borderWidth,
                                }}
                                onClick={ onOpen }
                            >
                                <Icon 
                                    icon={ primitive.overlayIcon as IconName || "phone-call"} 
                                    size={ primitive.overlayIconSize || 22 } 
                                    color={ primitive.overlayIconColor }
                                />
                                <CFAnimatedBorder primitive={ primitive } />
                            </div>
                            <ScalableDialog
                                isOpen={isOpen}
                                onClose={ () => setIsOpen(false) }
                                dialogSize={DIALOG_SIZE.NORMAL}
                            >
                                <div className="p-0"><ContactFormLayout {...props} /></div>
                            </ScalableDialog>
                        </>
                    :
                    <></>
        }
    </div>
}